<template>
  <form @submit.prevent="filter">
    <b-field label="ASSET TYPES" />
    <div class="field" v-for="type in typesSorted" :key="type.id">
      <b-checkbox :native-value="type.id" v-model="filters.types">{{
        type.name
      }}</b-checkbox>
    </div>
    <div class="columns">
      <div class="column is-6">
        <b-button class="is-fullwidth" size="is-small" @click="reset">
          RESET
        </b-button>
      </div>
      <div class="column is-6">
        <b-button
          class="is-fullwidth"
          native-type="submit"
          type="is-link"
          size="is-small"
        >
          FILTER
        </b-button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    assets: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    types: [],
    filters: {
      types: []
    },
    filtering: false,
    loadedInitial: false,
  }),
  computed: {
    assetsMap() {
      return this.$store.state.AssetsMap;
    },
    typesSorted() {
      let sorted = _.sortBy(this.types, 'name');
      return sorted;
    }
  },
  watch: {
    assets() {
      // Store old types
      // Used to check if new types are added
      const types = this.types.map(type => type.id);

      // Update types when original assets change
      this.types = this.assets.reduce((acc, asset) => {
        const code = asset.code || null;

        if (code && !acc.find(c => c.id === code.id)) {
          acc.push(code);
        }

        return acc;
      }, []);
      this.types = this.types.sort((a, b) => a.name.localeCompare(b.name));

      if (this.filtering) {
        // Check new types that are added
        this.types.forEach(type => {
          if (!types.includes(type.id)) {
            this.filters.types.push(type.id);
          }
        });

        this.$nextTick(() => {
          this.filter();
        });
      }

      // Check all checkboxes on initial load
      if (this.assets.length && !this.loadedInitial) {
        this.checkAllTypes();
        this.loadedInitial = true;
      }
    }
  },
  methods: {
    // This will be responsible for filtering the original assets and passing the filtered assets back to the offline map
    filter() {
      let assets = JSON.parse(JSON.stringify(this.assetsMap.assets));

      if (this.filters.types.length) {
        assets = assets.filter(
          asset => asset.code && this.filters.types.includes(asset.code.id)
        );
      } else {
        assets = [];
      }

      this.$emit("filter", assets);
      this.filtering = true;
    },
    reset() {
      this.checkAllTypes();
      this.$emit("reset");
      this.filtering = false;
    },
    checkAllTypes() {
      this.filters.types = this.types.map(type => type.id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetsOfflineMapLocalListFilters.vue